import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20illustration%20of%20a%20figure%20standing%20at%20the%20edge%20of%20light%20and%20shadow%2C%20warm%20golden%20and%20deep%20crimson%20color%20palette%2C%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20digital%20art%2C%20atmospheric%20fog%20and%20dramatic%20lighting%2C%20emotional%20and%20powerful%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="挣扎吧亚当君 - 沉浸式互动叙事体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-[900px] mx-auto">
          <p className="text-accent-400 text-sm md:text-base font-medium tracking-widest mb-4 animate-fade-in-up">
            —— 沉浸式互动叙事体验 ——
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight animate-fade-in-up [animation-delay:200ms]">
            挣扎吧<span className="text-accent-400">亚当君</span>
          </h1>
          <p className="text-background-100/90 text-base md:text-lg max-w-[650px] mx-auto mb-10 leading-relaxed animate-fade-in-up [animation-delay:400ms]">
            一款充满戏剧张力与深度叙事的互动体验作品。探索亚当君的挣扎历程，
            感受每一次选择背后的重量与意义。你的每一个决定，都将改写命运。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up [animation-delay:600ms]">
            <Link
              to="/category/all"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              探索攻略文章
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-md bg-background-50/10 text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}